let $smoothScrolls,
    responsiveOffset;

$(document).ready(function ($) {
    $smoothScrolls = $('.js-smoothscroll');
    responsiveOffset = -400;
    
    $smoothScrolls.each(function () {
        smoothScroll($(this));
    });
  });
  
  function smoothScroll(item) {
    $(item).on('click', function (e) {
      const href = $(this).attr('href');
      const targetOffset = $(href).offset().top;
      const isAnchor = href.startsWith('#');

      if (!isAnchor) {
        return;
      }
      
      e.preventDefault();
      
      if (getDeviceType() === 'mobile') {
        responsiveOffset = -300;
      }

      $('html, body').animate({scrollTop: targetOffset + responsiveOffset}, 800);
    });
}
